import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
/**
 * Custom launcher for the Freshworks support widget. We don't have admin access to
 * Freshworks' own widget appearance settings, so its default launcher bubble is hidden
 * (`FreshworksWidget('hide', 'launcher')` in `public/index.html`) and this button opens
 * it programmatically instead — styled to match the accessibility widget's floating
 * trigger (56px circle, portal primary color, bottom-left corner) so the two read as one
 * family of controls rather than two unrelated third-party widgets.
 *
 * Sits just right of the accessibility widget's own bottom-left trigger (`triggerPosition`
 * in `portalAccessibilityTheme.ts`). That widget is a separately-hosted remote we don't
 * control pixel-for-pixel, so this offset may need a nudge once both are on screen together.
 */
export function SupportWidgetButton() {
    const theme = useTheme();
    const handleClick = () => {
        window.FreshworksWidget?.('open');
    };
    return (_jsx(Tooltip, { title: "Support", placement: "right", children: _jsx(Box, { component: "button", type: "button", onClick: handleClick, "aria-label": "Open support chat", sx: {
                position: 'fixed',
                left: 84,
                bottom: 20,
                zIndex: 2147483000,
                width: 56,
                height: 56,
                p: 0,
                borderRadius: '28px',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: theme.palette.primary.main,
                color: '#ffffff',
                boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
                },
            }, children: _jsx(SupportAgentIcon, { sx: { fontSize: 28 } }) }) }));
}
